import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadFromStorage } from "@/lib/store/auth/authSlice";
import type { RootState } from "@/lib/store/store";
import { setUserId } from "@/src/services/analytics";

export function ReduxHydrator() {
  const dispatch = useDispatch();
  const token = useSelector((state: RootState) => state.auth.token);

  useEffect(() => {
    if (typeof window !== "undefined") {
      dispatch(loadFromStorage());
    }
  }, [dispatch]);

  useEffect(() => {
    void setUserId(token ?? null);
  }, [token]);

  return null;
}
